import DefaultPopup from '@r1-frontend/ui-react/components/popups/defaultPopup';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import styled from 'styled-components';

export const PopupAuth = styled(DefaultPopup)`
    width: calc(100% - 20px) !important;
    max-width: 600px !important;
    border-radius: ${BorderRadius.OuterBlockRadius};

    @media (max-width: 767px) {
        max-width: 530px !important;
    }
`;
